import React, { CSSProperties, RefObject, useCallback } from 'react';
import { Color } from '../enums/Color.enum';
import { ProductHandle } from '../enums/ProductHandle.enum';
import { useProductRating } from '../hooks/useProductRating';
import { ViewVariant } from '../models/ShopifyVariant.model';
import { ViewProduct } from '../models/ViewProduct.model';
import { ProductPrice } from './ProductPrice';
import ProductRating from './ProductRating';
import styles from './ProductPriceSummary.module.scss';
import { Pill } from './Pills';
import { useProductDiscountPercent } from '../hooks/useProductDiscountPercent';

interface Props {
  product: ViewProduct;
  variant?: ViewVariant;
  reviewsSectionRef?: RefObject<HTMLDivElement>;
  style?: CSSProperties;
  color?: Color;
}

export const ProductPriceSummary: React.FC<Props> = ({ product, variant, reviewsSectionRef, style, color }) => {
  const isGiftCard = product.handle === ProductHandle.EGiftCard;
  const rating = useProductRating(product);
  const percentOff = useProductDiscountPercent(product, variant, color);
  const discountMessage = product.isReturnable ? `${percentOff}% OFF` : `-${percentOff}%: FINAL SALE`;

  const gotoReviews = useCallback(() => {
    if (reviewsSectionRef?.current) {
      reviewsSectionRef.current.scrollIntoView();
    } else {
      window.location.href = `/products/${product.handle}#reviews`;
    }
  }, [reviewsSectionRef, product]);

  return (
    <div style={style}>
      <div className={styles.titlePrice} style={percentOff > 0 ? { minHeight: 75 } : {}}>
        <h1>{product.title}</h1>
        <ProductPrice product={product} variant={variant} color={color} />
        {percentOff > 0 && (
          <Pill isSmall={true} style={{ position: 'absolute', top: 32, right: -10, backgroundColor: '#A193ED', color: 'white' }} text={discountMessage} />
        )}
      </div>
      {!isGiftCard && <ProductRating rating={rating} onClick={gotoReviews} />}
    </div>
  );
};

export default ProductPriceSummary;
